import * as React from 'react';
import PropTypes  from 'prop-types';
import Spinner    from 'react-spinkit';

export default class InputComponent extends React.Component {

	render() {
		const isCheckboxOrRadio = this._checkIsCheckboxOrRadio(this.props);
		const props             = {
			id         : this.props.id,
			name       : this.props.name,
			onChange   : this._handleChange,
			placeholder: this.props.placeholder,
			readOnly   : this.props.readOnly,
			required   : this.props.required,
			type       : this.props.type,
			defaultValue      : this.props.value
		};

		if (!isCheckboxOrRadio) {
			props.className = 'form-control';
		}

		if (this.props.disabled) {
			props.disabled = true;
		}

		if ('date' === this.props.type
		|| 'month' === this.props.type
		|| 'week' === this.props.type
		|| 'datetime-local' === this.props.type
		|| 'number' === this.props.type) {
			if (this.props.min) props.min = this.props.min;
			if (this.props.max) props.max = this.props.max;
		}

		if ('number' === this.props.type && this.props.step) {
			props.step = this.props.step;
		}

		if (isCheckboxOrRadio) {
			props.defaultChecked    = this.props.checked;
			const disabledClassName = this.props.disabled ? ' disabled': '';
			return (
				this.props.inline
					? <label className={`${this.props.type}-inline${disabledClassName}`}>
							<input {...props} />
							{this.props.label}
						</label>
					: <div className={`${this.props.type}${disabledClassName}`}>
							<label>
								<input {...props} />
								{this.props.label}
							</label>
						</div>
			)
		}

		const otherwhise = this.props.loading || this.props.prefixes.length || this.props.suffixes.length
			? <div className="input-group">
					{this.props.loading && <span className="input-group-addon"><Spinner fadeIn="none" name="wave" /></span>}
					{this.props.prefixes.map((p, i) => <span className="input-group-addon" key={i}>{p}</span>)}
					<input {...props} />
					{this.props.suffixes.map((s, i) => <span className="input-group-addon" key={i}>{s}</span>)}
				</div>
			: <input {...props} />

		if (this.props.label) {
			return (
				<div className="form-group">
					<label className="col-sm-2 control-label" htmlFor={this.props.id}>{this.props.label}</label>
					<div className="col-sm-10">{otherwhise}</div>
				</div>
			);
		}

		return otherwhise;
	}

	_checkIsCheckboxOrRadio = (props) => {
		return 'checkbox' === props.type || 'radio' === props.type;
	}

	_getValue = (props) => {
		if (true === props.value)  return 'true';
		if (false === props.value) return 'false';
		return props.value || '';
	}

	_handleChange = (/** @type {React.SyntheticEvent<Element>} */ event) => {
		this.props.onChange && this.props.onChange(event);
	}
}

InputComponent.propTypes = {
	checked      : PropTypes.bool,
	disabled     : PropTypes.bool,
	id           : PropTypes.string,
	label        : PropTypes.string,
	name         : PropTypes.string,
	onChange     : PropTypes.func,
	placeholder  : PropTypes.string,
	prefixes     : PropTypes.array,
	readOnly     : PropTypes.bool,
	required     : PropTypes.bool,
	suffixes     : PropTypes.array,
	type         : PropTypes.string.isRequired,
	value        : PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.number,
		PropTypes.string
	])
};

InputComponent.defaultProps = {
	prefixes: [],
	suffixes: []
};


// WEBPACK FOOTER //
// ./src/component/form/input/input-component.js